import React from 'react'
import { AiFillProduct, AiFillRead } from 'react-icons/ai'
import { FaChalkboardTeacher } from 'react-icons/fa'

const WhyChoseContent = () => {
  return (
    <>
      <section class="bg-dark">
        <div class="container-fluid">
            <div class="row no-guuters">
                <div class="col-lg-6 d-none d-lg-block">
                    <img src="/images/bg/banner-2.png" alt="" style={{objectFit:'cover', width:'100%', height:'100%'}} />
                </div>
                <div class="col-lg-6 px-4 px-md-5 px-lg-6 py-6 px-lg-6" style={{backgroundImage: `url(images/about/pattern.png)`}}>
                    <div class="section-title">
                        <h2 class="title">Why Choose Us</h2>
                    </div>
                    <div class="media d-flex gap-3">
                        <span className='border'><AiFillProduct /></span>
                        <div class="media-body">
                            <h5 class="mt-0 mb-3">Pollution Free Campus</h5>
                            <p class="text-white mb-0">We believe that a clean and green environment enhances learning. Our campus is designed to be eco-friendly, promoting sustainability through tree plantations, waste management, and pollution control initiatives.</p>
                        </div>
                    </div>
                    <span class="border-bottom d-block my-5 border-light"></span>
                    <div class="media d-flex gap-3">
                        <span className='border fa-3x'><AiFillRead /></span>
                        <div class="media-body">
                            <h5 class="mt-0 mb-3">Fun & Engaging Learning</h5>
                            <p class="text-white mb-0">We make education fun and engaging through interactive methods such as group discussions, role-playing, field trips, and creative projects, ensuring that every child learns in an enjoyable and meaningful way.</p>
                        </div>
                    </div>
                    <span class="border-bottom d-block my-5 border-light"></span>
                    <div class="media d-flex gap-3">
                        <span className='border fa-3x'><FaChalkboardTeacher /></span>
                        <div class="media-body">
                            <h5 class="mt-0 mb-3">Holistic Development</h5>
                            <p class="text-white mb-0">Our holistic approach to education ensures that students develop critical thinking, leadership skills, and a sense of social responsibility. We empower students to excel in all aspects of life and become confident, compassionate global citizens.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}

export default WhyChoseContent
